import { useEffect, useState } from "react";
import SectionHeading from "@/components/base/SectionHeading";
import VideoCard from "@/components/base/VideoCard";
import SkeletonCard from "@/components/base/SkeletonCard";
import { getCategoryBySlug, getLatestVideos } from "@/lib/video";

export default function LatestVideosSection() {
  const [loading, setLoading] = useState(true);
  const latest = getLatestVideos(6);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section>
      <SectionHeading
        title="最新上传"
        subtitle="刚刚上线的新鲜内容，第一时间看个够"
        icon="ri-time-line"
        moreLabel="搜索更多"
        moreTo="/search"
      />
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        {loading ? (
          <SkeletonCard count={6} />
        ) : (
          latest.map((video) => (
            <VideoCard
              key={video.id}
              video={video}
              categoryName={getCategoryBySlug(video.category)?.name}
            />
          ))
        )}
      </div>
    </section>
  );
}